import React from 'react';
import {injectIntl} from 'react-intl';
import Block from '@Components/Block';

const TopCities = ({intl, title, cities, baseUrl}) => {
  const renderCities = () => {
    let result = [];
    if (cities?.length) {
      result = cities.slice(0, 8).map((city, key) => {
        const params = city.fullCityName.split(', ');
        const cityPath = `${baseUrl}${params[0].replace(/ /g, '_')}-${params[1].replace(/ /g, '_')}/`;

        return (
          <div className="top-city divider" key={key}>
            <div className="top-city__city">
              <div className="top-city__label hidden--from-l">{intl.formatMessage({id: 'TopCities.City'})}</div>
              <a className="top-city__name" href={cityPath}>
                {city.abbrCityName}
              </a>
            </div>
            <div className="top-city__salary">
              <div className="top-city__label hidden--from-l">{intl.formatMessage({id: 'TopCities.Salary'})}</div>
              <div className="top-city__name">{city.topSalary}</div>
            </div>
          </div>
        );
      });

      result.unshift(
          <div className="top-city divider hidden--until-l" key="top-city-header">
            <div className="top-city__city">
              <div className="top-city__name">
                {intl.formatMessage({id: 'TopCities.City'})}
              </div>
            </div>
            <div className="top-city__salary">
              <div className="top-city__name">
                {intl.formatMessage({id: 'TopCities.Salary'})}
              </div>
            </div>
          </div>,
      );
    }
    return result;
  };

  const renderImage = () => (
    <div className="top-city__description-image hidden--until-l">
      <img src="/salary-app/assets/images/handMoney.svg" alt={intl.formatMessage({id: 'Image.HandMoney.Alternative'})}/>
    </div>
  );

  return (
    <Block title={title} blockSmall={true} description={renderImage()} noIntl={true}>
      {renderCities()}
      <div className="top-city__footer text--alternative">{intl.formatMessage({id: 'TopCities.Footer'})}</div>
    </Block>
  );
};

export default injectIntl(TopCities);
